// Copyright (c) 2022 by Move Closer

import { ComponentInternalInstance, computed, PropType, toRefs } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { hasSizeProp, useOptionClass, useSizeClass } from '../../composables'

import { HeadingProps, Level, UseCustomHeadingProvides } from './Heading.contracts'
import { sizeClassRegistry } from './Heading.config'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (edited)
 */
export const customHeadingProps: ComponentObjectPropsOptions<HeadingProps> = {
  ...hasSizeProp,

  content: {
    type: String,
    required: false,
    default: ''
  },

  level: {
    type: Number as PropType<Level>,
    required: false,
    default: () => Level.Level1
  },

  wrappers: {
    type: Array,
    required: false,
    default: () => ([])
  },

  decorator: {
    type: String,
    required: false,
    default: () => ''
  }
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (edited)
 */
export const useCustomHeading = (
  props: HeadingProps,
  internalInstance: ComponentInternalInstance | null
): UseCustomHeadingProvides => {
  const { level, size, wrappers, decorator } = toRefs(props)

  if (internalInstance === null) {
    throw new Error('useLink(): FATAL ERROR! Failed to resolve the component instance!')
  }

  const { type } = internalInstance
  const { sizeClass } = useSizeClass<string>(
    size,
    sizeClassRegistry,
    `${type._componentTag}`
  )

  const decoratorClass = useOptionClass(decorator?.value)

  const steps = computed<string[]>(() => {
    const steps = [...wrappers.value]
    steps.unshift(typeof props.level === 'number' ? `h${level.value}` : 'h1')
    return steps
  })

  return { sizeClass, steps, decoratorClass }
}
